import {
    Card, Grid, Typography
} from "@mui/material";
import { generateBoardMemberMeetingsPDFApi, getReportBoardMemberMeetingsApi } from 'api/report';
import ReportBoardMemberFilterCard from "app/components/Card/report/ReportBoardMemberFilterCard";
import ReportBoardMemberTable from "app/components/Table/reports/ReportBoardMemberTable";
import React, { useState } from "react";

const ReportBoardMemberPage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [lastFilter, setLastFilter] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);

    const setFilterData = (data) => {
        setData(data);
    };

    const handleResultListBoardMember = async (filters) => {
        setLoading(true);
        setHasSearched(true);
        try {
            const res = await getReportBoardMemberMeetingsApi(filters);
            const responseData = res.data?.data || res.data || [];
            setFilterData(responseData);
            setLastFilter(filters);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const generateBoardMemberPDF = async () => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await generateBoardMemberMeetingsPDFApi(lastFilter);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Grid container sx={{ marginBottom: 4 }}>
                <Grid item xs={12} md={12}>
                    <ReportBoardMemberFilterCard
                        title="Üye Aylık Toplantı Raporu"
                        setFilterData={setFilterData}
                        handleResultList={handleResultListBoardMember}
                        generatePDFApi={generateBoardMemberPDF}
                    />
                </Grid>
            </Grid>

            {hasSearched && (
                <Card sx={{ padding: 2 }}>
                    {data.length > 0 ? (
                        <ReportBoardMemberTable data={data} />
                    ) : (
                        <Typography
                            variant="h6"
                            sx={{
                                textAlign: 'center',
                                color: 'text.secondary',
                                padding: 3
                            }}
                        >
                            Sonuç bulunamadı
                        </Typography>
                    )}
                </Card>
            )}
        </React.Fragment>
    );
};

export default ReportBoardMemberPage; 